import React, { useEffect, useState } from 'react'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

const InstallAppButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null)
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    const onBeforeInstallPrompt = (event: Event) => {
      event.preventDefault()
      setDeferredPrompt(event as BeforeInstallPromptEvent)
    }

    const onAppInstalled = () => {
      setIsInstalled(true)
      setDeferredPrompt(null)
    }

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    if (isStandalone) {
      setIsInstalled(true)
    }

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)
    window.addEventListener('appinstalled', onAppInstalled)

    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt)
      window.removeEventListener('appinstalled', onAppInstalled)
    }
  }, [])

  const handleInstall = async () => {
    if (!deferredPrompt) {
      window.alert(
        'Tu navegador no habilito la instalacion directa. Puedes crear el acceso directo desde el menu del navegador: "Instalar aplicacion" o "Crear acceso directo".'
      )
      return
    }

    await deferredPrompt.prompt()
    const choiceResult = await deferredPrompt.userChoice
    if (choiceResult.outcome === 'accepted') {
      setDeferredPrompt(null)
    }
  }

  if (isInstalled) return null

  return (
    <button
      onClick={handleInstall}
      style={{
        position: 'fixed',
        right: '16px',
        bottom: '16px',
        zIndex: 2000,
        borderRadius: '10px',
        border: '1px solid #b8860b',
        background: '#b8860b',
        color: '#fff',
        padding: '10px 14px',
        cursor: 'pointer',
        fontWeight: 600,
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      }}
      type="button"
    >
      Instalar app
    </button>
  )
}

export default InstallAppButton
